import React, { Component } from 'react';
import { connect } from 'react-redux';
import setEditMode from '../../actions/setEditMode';
import { inject, observer } from 'mobx-react'

class EditorToggler extends Component {
  render() {
    if(!this.props.meStore.me.inited) {
      return null;
    }
    return (
      <div className={`dib tac menuSquare pointer ${this.props.appStateStore.editor_mode?'w1 bg-b1':'sc1'}`} onClick={()=>{ this.props.appStateStore.editor_mode=!this.props.appStateStore.editor_mode; }}>
        <div className="up12 splice h100">
          <div className="cell s-middle s-auto">
            <i className="mdi mdi-settings fs30 "></i>
          </div>
        </div>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    me:state.me,
    editor_mode:state.editor_mode,
  }
}

// export default connect(mapStateToProps, { setEditMode })(EditorToggler);
export default inject("meStore","appStateStore")(observer(EditorToggler));